module.exports = __webpack_public_path__ + "img/home-marketcard-logo.4802e276.png";